"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceIsSchema = void 0;
const zod_1 = require("zod");
const lingo2_models_1 = require("lingo2-models");
exports.UserServiceIsSchema = zod_1.z.record(zod_1.z.nativeEnum(lingo2_models_1.UserServiceStateEnum), zod_1.z.boolean());
